// repo: https://vuemc.io/#basic-usage
import {Model, Collection} from 'vue-mc'
import isPresent from 'is-present'
import {Addon} from "./addon";

class RegistrationAddon extends Model {
  defaults() {
    return {
      id: null,
      eligibility_requirement: null,
      choice_ids: [],
      other_amount: {},
      addon: {},
    }
  }
  mutations() {
    return {
      id:   (id) => Number(id) || null,
      addon: (json)=>{ return new Addon(json)}
    }
  }
}

export {
  RegistrationAddon
}